module.exports = __webpack_public_path__ + "img/pic_map.3026b075.svg";